import { DydAvatar, DydChatPanel, COACH_IMG } from "@/components/Dyd";
import { Sparkle, Trophy, CreditCard, IdentificationCard, Question } from "@phosphor-icons/react";

const SUGGESTED = [
  { icon: Trophy, text: "¿Qué torneos están abiertos?", testId: "dyd-suggest-tournaments" },
  { icon: IdentificationCard, text: "¿Cómo cambio mi categoría?", testId: "dyd-suggest-category" },
  { icon: CreditCard, text: "¿Cómo subo un comprobante de pago?", testId: "dyd-suggest-payments" },
  { icon: Question, text: "¿Cómo creo una reta?", testId: "dyd-suggest-retas" },
];

export default function DydCoach() {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="dyd-coach-page">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#CCFF00] mb-1">Asistente Pro</p>
          <h1 className="font-['Barlow_Condensed'] text-4xl sm:text-5xl font-black uppercase tracking-tighter">DYD Coach</h1>
          <p className="text-sm text-gray-400 mt-1 max-w-xl">
            Tu gestor personal de pádel. Te ayudo con inscripciones, pagos, configuración del perfil
            y cualquier duda sobre tu juego. <span className="text-[#CCFF00]">Yo me encargo de la logística para que tú solo te encargues de ganar.</span>
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6 items-start">
        {/* Coach avatar card */}
        <div className="card-tactical p-4 sm:p-6 flex flex-col items-center text-center lg:sticky lg:top-4" data-testid="dyd-coach-card">
          <div className="relative w-32 h-32 sm:w-48 sm:h-48 lg:w-56 lg:h-56 flex items-center justify-center bg-[#0A0A0A] border border-[#CCFF00]/30 mb-4">
            <DydAvatar src={COACH_IMG} size={224} className="object-contain max-w-full max-h-full" testId="dyd-coach-img" />
            <div className="absolute -bottom-2 -right-2 bg-[#CCFF00] text-black text-[10px] font-bold uppercase tracking-widest px-2 py-1 flex items-center gap-1">
              <Sparkle size={10} weight="fill" /> ONLINE
            </div>
          </div>
          <p className="font-['Barlow_Condensed'] text-2xl font-black uppercase">DYD</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-[0.2em] mt-1">Tu Coach Digital</p>

          <div className="mt-6 w-full">
            <p className="text-[10px] tracking-[0.2em] uppercase font-semibold text-gray-500 mb-2">Sugerencias</p>
            <div className="space-y-1.5">
              {SUGGESTED.map((s) => (
                <button
                  key={s.text}
                  type="button"
                  onClick={() => {
                    const input = document.querySelector('[data-testid="dyd-input-coach"]');
                    if (input) {
                      const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                      setter.call(input, s.text);
                      input.dispatchEvent(new Event("input", { bubbles: true }));
                      input.focus();
                    }
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-left text-[11px] text-gray-300 hover:text-[#CCFF00] hover:bg-[#CCFF00]/5 border border-white/10 hover:border-[#CCFF00]/30 transition-colors"
                  data-testid={s.testId}
                >
                  <s.icon size={14} className="text-[#CCFF00] shrink-0" />
                  <span className="truncate">{s.text}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Chat */}
        <div className="card-tactical flex flex-col" data-testid="dyd-coach-chat-wrapper">
          <div className="p-4 border-b border-white/10 bg-[#0A0A0A]">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#CCFF00] mb-0.5">Conversación</p>
            <p className="text-[11px] text-gray-500">Chat persistente. Tu historial se conserva entre sesiones.</p>
          </div>
          <DydChatPanel role="coach" />
        </div>
      </div>
    </div>
  );
}
